import { useS4LContext } from '@s4l/react-context'
import React from 'react'
import { PriceContext } from '..'

const TotalNights = ({ show = true }: { show?: boolean }) => {
  const { i18n } = useS4LContext()
  const { nights } = React.useContext(PriceContext)

  if (!nights || !show) return null

  return <>&nbsp;({i18n.formatMessage({ id: 'global.nights' }, { nights })})</>
}

export default TotalNights
